// extracted by mini-css-extract-plugin
module.exports =  {"form":"Bhs108"};